import React from 'react'
import { Col, Row } from 'react-bootstrap'
import { LinkExternal } from 'Components/LinkExternal'
import { Dropzone } from 'Components/Form/Dropzone'

const BatchImportForm = ({ className, onChange }) => (
  <div>
    <Row className={className}>
      <Col xs={6}>
        <LinkExternal
          href="https://s3-ap-southeast-2.amazonaws.com/prod-oppizi-cdn/locations-import-sample.csv"
          target="_blank"
        >
          Download the csv template
        </LinkExternal>
      </Col>
      <Col xs={6}>
        <Dropzone
          input={{
            onChange,
          }}
          meta={{ touched: false, error: null }}
        />
      </Col>
    </Row>
  </div>
)

export default BatchImportForm



// WEBPACK FOOTER //
// ./src/Containers/Form/City/Locations/BatchImport/unstyled.js